// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2EZaI","content":"RecentSearches_content__2ohbA"};